export default __webpack_public_path__ + "static/media/plus.9e36db73.svg";